<template>
  <div class="auth-popup-phone-input">
    <div class="auth-popup-phone-input__desc">
      Для получения пароля введите свой номер
      телефона, подтвердите, что вы не робот,
      и нажмите кнопку “Далее”
    </div>
    <div class="auth-popup-phone-input__wrapper">
      <input
        type="phone"
        v-model="phone"
        v-input-mask
        data-inputmask-mask="+7 (999) 999 99 99"
        placeholder="+7 (___) ___ __ __">
    </div>
    <div class="auth-popup-phone-input__wrapper-captcha">
      <VueRecaptcha
        sitekey="6LdfackUAAAAAGLD5hCBQdnZhdLDZdlalXQpSDQv"
        :loadRecaptchaScript="true"
        @verify="onVerify"
        @expired="onExpired"/>
    </div>
    <div class="auth-popup-phone-input__wrapper-login">
      <div
        class="authorize-links__item link"
        :class="{disable: !isValid}"
        @click="sendPhone">Далее
      </div>
    </div>
  </div>
</template>

<script>
  import VueRecaptcha from 'vue-recaptcha'
  import {mapActions, mapGetters} from 'vuex'

  export default {
    name: 'PhoneInputPopup',
    components: {
      VueRecaptcha
    },
    data: function () {
      return {
        phone: '',
        isCaptcha: false
      }
    },
    mounted: function () {
      this.phone = this.getSavePhone
    },
    computed: {
      ...mapGetters('auth', [
        'getSavePhone'
      ]),
      isValid: function () {
        return this.phone.replace(/[()_ ]/g, '').length === 12 && this.isCaptcha
      }
    },
    methods: {
      ...mapActions('auth', [
        'sendSmsByPhone'
      ]),
      onVerify: function () {
        this.isCaptcha = true
      },
      onExpired: function () {
        this.isCaptcha = false
      },
      sendPhone: function () {
        if (this.isValid) {
          this.sendSmsByPhone({
            phone: this.phone
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Auth/Popups/PhoneInputPopup.vue